import { PqdSqlClient } from '../sqlite/pdq-sqlite-client';
import { Mutex } from '../utils';
import Debug from 'debug';
import { Subject } from 'rxjs';
const log = Debug('pdq:sqlite:SqliteBroker');

export class SqliteBroker {
  private _client:PqdSqlClient|undefined
  private _mutex = new Mutex('SqliteBroker');

  private tableUpdatedSubject = new Subject<{database: string, table: string}>()
  private _tableUpdatedSubject= this.tableUpdatedSubject.asObservable()
  get tableUpdated() {return this._tableUpdatedSubject}

  constructor() {
    this._tableUpdatedSubject.subscribe(i => {
      log(`table updated`, i)
    })
  }

  private async setup(path: string) {
    if (!this._client)
      this._client = new PqdSqlClient(path);
    return this._client
  }

  async getDatabaseClient(path: string, alias: string = 'main', note: string = '-'): Promise<PqdSqlClient> {
    log(`getDatabaseClient[${note}]`, path, alias)
    const unlock = await this._mutex.lock()
    try {
      if (alias == 'main') {
        if (this._client) {
          return this._client!
        }
        await this.setup(path);
        return this._client!;
      }

      if (!this._client)
        throw new Error('init the main database first...') // todo -- await a main db promise here?

      const dbs = await this._client.query('PRAAGMA database_list');
      if (dbs.filter(i => i.name == alias)) {
        return this._client!
      }

      await this._client.query(`ATTACH DATABASE '${path}' AS ${alias}`);
      return this._client
    }finally{
      unlock()
    }
  }

  notifyTableUpdated(database: string, table: string) {
    this.tableUpdatedSubject.next({database, table})
  }
}


export const sqliteBroker = new SqliteBroker();